import { render, staticRenderFns } from "./AppointmentsSchedule.vue?vue&type=template&id=35770363&scoped=true"
import script from "./AppointmentsSchedule.vue?vue&type=script&lang=ts"
export * from "./AppointmentsSchedule.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentsSchedule.vue?vue&type=style&index=0&id=35770363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35770363",
  null
  
)

export default component.exports